module.exports = __webpack_public_path__ + "static/media/internal.f3cf1d32.svg";